import React, { useEffect, useState } from "react";
import { EdicionProduccionApi } from "../api/EdicionProduccionApi";
import { NotificationManager } from "react-notifications";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../utility/utils";
import { useForm } from "react-hook-form";
import moment from "moment";
import { ESTADOS_PRODUCCION } from "../../../../../../../../utility/constants";
import { ProduccionV2Api } from "../../../../api/ProduccionV2Api";

export const useProduccionForm = (idProduccion, regresar) => {
    const {
        agregarOrdenProduccion,
        eliminarOrdenProduccion,
        actualizarKgOrdenProduccion,

        actualizarProduccion,
        getDetalleProduccion,
        cargando,
    } = EdicionProduccionApi();

    const { completarOrdenProduccion } = ProduccionV2Api();

    const [isProduccionPendiente, setIsProduccionPendiente] = useState(true);
    const [ordenesProduccion, setOrdenesProduccion] = useState([]);

    const [cargaInicial, setCargaInicial] = useState(true);

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: formWatch,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
    });

    const GetDetalleProduccion = async () => {
        try {
            const data = await getDetalleProduccion(idProduccion);

            // llenar datos generales de la producción solo si no se habían cargado
            if (cargaInicial) {
                formSetValue("numero", data.numero);
                formSetValue("anio", data.anio);
                formSetValue("semana", data.semana);
                formSetValue("fecha_inicial", moment(data.fecha_inicial));
                formSetValue("fecha_final", moment(data.fecha_final));
            }
            setCargaInicial(false);

            setOrdenesProduccion(
                data.ordenes_produccion.map((orden) => ({
                    id: orden.id,
                    kg_a_producir: orden.kg_a_producir,
                    evs: orden.evs,
                    estado: orden.estado,
                    kg_paletizados: orden.kg_paletizados,
                    kg_pendientes: orden.kg_pendientes,
                })),
            );

            // Verificar si la producción está pendiente
            setIsProduccionPendiente(
                data.estado === ESTADOS_PRODUCCION.PENDIENTE,
            );
        } catch (error) {
            setOrdenesProduccion([]);

            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cargar el detalle de la producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (idProduccion) {
            GetDetalleProduccion();
        }
    }, [idProduccion]);

    const AgregarOrdenProduccion = async (orden) => {
        try {
            const response = await agregarOrdenProduccion(idProduccion, {
                kg_a_producir: orden.kg_a_producir,
                evs_id: orden.evs.id,
            });

            NotificationManager.success(
                "Orden de producción agregada con éxito",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al agregar la orden de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            throw error;
        } finally {
            GetDetalleProduccion();
        }
    };

    const EliminarOrdenProduccion = async (idOrden) => {
        try {
            await eliminarOrdenProduccion(idOrden);
            NotificationManager.success(
                "Orden de producción eliminada con éxito",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar la orden de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            throw error;
        } finally {
            GetDetalleProduccion();
        }
    };

    const ActualizarKgOrdenProduccion = async (idOrden, kgAProducir) => {
        try {
            await actualizarKgOrdenProduccion(idOrden, kgAProducir);

            NotificationManager.success(
                "Kilogramos actualizados con éxito",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar los kilogramos de la orden de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            throw error;
        } finally {
            GetDetalleProduccion();
        }
    };

    const CompletarOrdenProduccion = async (idOrden) => {
        try {
            await completarOrdenProduccion(idOrden);
            NotificationManager.success(
                "Orden de producción detenida con éxito",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al detener la orden de producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            throw error;
        } finally {
            GetDetalleProduccion();
        }
    };

    const FormSubmit = async () => {
        const valid = await validateForm();
        if (!valid) return;

        // si no hay ordenes de producción, mostrar advertencia
        if (ordenesProduccion.length === 0) {
            NotificationManager.warning(
                "Debe agregar al menos una orden de producción",
                "Advertencia",
                3000,
            );
            return;
        }

        const formValues = formGetValues();

        const body = {
            anio: formValues.anio,
            semana: formValues.semana,
            fecha_inicial: dateToDayStart(formValues.fecha_inicial),
            fecha_final: dateToDayEnd(formValues.fecha_final),
        };

        await ActualizarProduccion(body);
    };

    const ActualizarProduccion = async (body) => {
        try {
            // Lógica para guardar la gestión de almacén
            await actualizarProduccion(idProduccion, body);

            NotificationManager.success(
                "Producción actualizada con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar la producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            GetDetalleProduccion();
        }
    };

    return {
        formControl,
        formRegister,
        formErrors,
        formWatch,
        formGetValues,
        formSetValue,
        validateForm,

        AgregarOrdenProduccion,
        EliminarOrdenProduccion,
        ActualizarKgOrdenProduccion,
        CompletarOrdenProduccion,

        ordenesProduccion,
        FormSubmit,
        cargando,
        isProduccionPendiente,
    };
};
